import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 15v-6l7.745 10.65a9 9 0 1 1 2.255 -1.993","key":"svg-0"}],["path",{"d":"M15 12v-3","key":"svg-1"}]]

/**
 * IconBrandNextjs
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtbmV4dGpzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik05IDE1di02bDcuNzQ1IDEwLjY1YTkgOSAwIDEgMSAyLjI1NSAtMS45OTMiIC8+CiAgPHBhdGggZD0iTTE1IDEydi0zIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-nextjs
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandNextjs = createReactComponent('outline', 'brand-nextjs', 'BrandNextjs', __iconNode);

export default IconBrandNextjs;